import {createContext, useContext, FC} from 'react';

import {GemInitializeComponentsProps} from 'app/utils/initialize/interface';

const GemInitializeComponentsContext = createContext<FC<GemInitializeComponentsProps> | undefined>(undefined);

/**
 * To be used by remotes to get the GemInitializeComponents component.
 * Temporary solution until all components are migrated to Web Components.
 */
export function useGemInitializeComponents() {
    return useContext(GemInitializeComponentsContext);
}

export const GemInitializeComponentsProvider = GemInitializeComponentsContext.Provider;
